<template>
<div class="vx-col md:w-full w-full mb-base">
    <vx-card>
        <vs-popup classContent="popup-example" :title="titleModal" :active.sync="modalPeriodo">
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <label>Fecha inicial</label>
                    <vs-input class="inputx w-full" type="date" v-model="periodo.fecha_inicial" />
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <label>Fecha Final</label>
                    <vs-input class="inputx w-full" type="date" v-model="periodo.fecha_final" />
                </div>
                <div class="vx-col w-full mt-5">
                    <label>Periodo escolar</label>
                    <vs-input class="inputx w-full" placeholder="Periodo escolar" v-model="periodo.periodoescolar" />
                </div>
                <div class="vx-col w-full mt-5">
                    <label>Descripción</label>
                    <vs-input class="inputx w-full" placeholder="Descripcion" v-model="periodo.descripcion" />
                </div>
                <div class="vx-col sm:w-1/2 w-full mt-5">
                    <vs-radio v-model="periodo.region_idregion" vs-name="radios1" class="m-2" vs-value="1">Sierra</vs-radio>
                    <vs-radio v-model="periodo.region_idregion" vs-name="radios1" class="m-2" vs-value="2">Costa</vs-radio>
                </div>
                <div class="vx-col sm:w-1/2 w-full mt-5">
                    <vs-radio v-model="periodo.estado" vs-name="estado1" class="m-2" color="success" vs-value="1">Activo</vs-radio>
                    <vs-radio v-model="periodo.estado" vs-name="estado1" class="m-2" color="danger" vs-value="0">Inactivo</vs-radio>
                </div>
                <div class="vx-col sm:w-1/2 w-full mt-5">
                    <vs-button @click="agregarPeriodo();" color="primary" type="filled">Guardar Cambios</vs-button>
                </div>
            </div>

        </vs-popup>
        <!-- FIN POPUP DE EDITAR-->

        <div>
            <!--Tabla para el listado de la tabla periodos-->
            <vs-table stripe max-items="50" search pagination :data="listaPeriodos">
                <template slot="header">
                    <vs-button @click="abrirModal();" style="margin-left: 5px;" color="success" type="filled">
                        + Agregar periodo
                    </vs-button>
                </template>
                <template slot="thead">
                    <vs-th>Nombre</vs-th>
                    <vs-th>Periodo</vs-th>
                    <vs-th>Region</vs-th>
                    <vs-th>Estado</vs-th>
                    <vs-th>Acciones</vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].descripcion">
                            {{data[indextr].descripcion}}
                        </vs-td>
                        <vs-td :data="data[indextr].periodoescolar">
                            {{data[indextr].periodoescolar}}
                        </vs-td>
                        <vs-td :data="data[indextr].region_idregion">
                            <label v-if="data[indextr].region_idregion == '1'">SIERRA</label>
                            <label v-if="data[indextr].region_idregion == '2'">COSTA</label>
                        </vs-td>
                        <vs-td :data="data[indextr].estado">
                            <label v-if="data[indextr].estado == '1'" class="text-success">Activo</label>
                            <label v-if="data[indextr].estado == '0'" class="text-danger">Inactivo</label>
                        </vs-td>
                        <vs-td :data="tr">
                            <div class="flex">
                                <vs-button type="border" size="small" icon-pack="feather" icon="icon-edit" class="mr-2" color="success" @click="editModal(data[indextr]);"></vs-button>
                                <vs-button color="danger" size="small" type="border" icon-pack="feather" icon="icon-trash" @click="confirmarEliminar(data[indextr].idperiodoescolar)"></vs-button>
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
    </vx-card>
</div>
</template>

<script>
export default {
    components: {
    },
    data() {
        return {
            listaPeriodos: '',
            modalPeriodo: false,
            periodo: {
                'idperiodoescolar': '',
                'fecha_inicial': '',
                'fecha_final': '',
                'descripcion': '',
                'region_idregion': '',
                'periodoescolar': '',
                'estado': 1,
            },
            titleModal: '',
            id_eliminar: '',
        }
    },
    mounted() {
        let me = this;
        me.getPeriodos();
    },
    methods: {
        getPeriodos() {
            let me = this;
            me.$vs.loading();
            me.$http.get(this.$server_url+'periodos')
            // axios.get('http://localhost:8000/api/periodos')
                .then(res => {
                    // console.log(res.data);
                    me.listaPeriodos = res.data;
                    me.$vs.loading.close();
                })
                .catch(err => {
                    console.lor(err)
                    me.$vs.loading.close();
                })
        },
        abrirModal() {
            let me = this;
            me.titleModal = 'Agregar periodo';
            me.modalPeriodo = true;
        },
        editModal(item) {
            let me = this;
            me.titleModal = 'Editar periodo';
            // return
            me.periodo = item;
            me.modalPeriodo = true;
        },
        agregarPeriodo() {
            let me = this;
            me.$vs.loading();
            // console.log(me.periodo)
            me.$http.post(this.$server_url+'periodos',  me.periodo)
            // axios.post('http://localhost:8000/api/periodos', me.periodo)
                .then(() => {
                    // console.log(res.data);
                    me.$vs.notify({
                        text: 'Contenido agregado correctamente',
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-check'
                    })
                    me.getPeriodos();
                    me.$vs.loading.close();
                    me.modalPeriodo = false;
                })
                .catch(err => {
                    console.log(err);
                    me.$vs.notify({
                        text: 'No se agregó el contenido',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    })
                    me.$vs.loading.close();
                })
        },
        confirmarEliminar(item) {
            let me = this;
            me.id_eliminar = item;
            // console.log(me.id_eliminar)
            me.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: 'Confirmar',
                text: 'Seguro desea eliminar este item?',
                acceptText: 'Aceptar',
                cancelText: 'Cancelar',
                accept: me.eliminarPeriodo
            })
        },
        eliminarPeriodo() {
            let me = this;
            me.$vs.loading();
            me.$http.get(this.$server_url+'eliminaPeriodo/'+ me.id_eliminar)
            // axios.get('http://localhost:8000/api/eliminaPeriodo/' + me.id_eliminar)
                .then(() => {
                    me.$vs.notify({
                        text: 'Periodo eliminado correctamente',
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-check'
                    })
                    me.getPeriodos();
                    me.$vs.loading.close();
                })
                .catch(err => {
                    console.log(err)
                    me.$vs.loading.close();
                })
        }
    }
}
</script>
